import cx from 'classnames';
import React, { ReactNode } from 'react';

import styles from './TimelineButton.module.scss';

type TTimelineButton = {
  children: ReactNode;
  disabled?: boolean;
  active?: boolean;
  onClick?: () => void;
  onContextMenu?: () => void;
  className?: string;
  style?: any;
  'data-preserve-clip-edit'?: boolean;
};

export const TimelineButton: React.FC<TTimelineButton> = ({
  children,
  onClick,
  disabled,
  active,
  className,
  style,
  onContextMenu,
  ...additionalTriggers
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={cx({ [styles.timelineButton]: true, [styles.timelineButtonActive]: active }, className)}
      onContextMenu={onContextMenu}
      {...additionalTriggers}
    >
      {children}
    </button>
  );
};
